import { useSearchUpdate } from 'hooks/useSearch';
import { Button, Form } from 'react-bootstrap';
import { FaXmark } from 'react-icons/fa6';

export default function SearchBar({
  className,
  inputClassName,
  disabled,
  placeholder = 'Search',
  includeClear = true,
}) {
  const [search, updateSearch] = useSearchUpdate();

  return (
    <Form.Group
      className={`d-flex w-100 rounded-3 border border-1 border-secondary bg-primary ${className}`}
    >
      <Form.Control
        className={`border-0 rounded-0 bg-transparent ${inputClassName}`}
        disabled={disabled}
        value={search || ''}
        onChange={(event) => updateSearch(event.target.value)}
        placeholder={placeholder}
      />
      {includeClear && !disabled && (
        <Button
          className="bg-transparent border-0"
          onClick={() => updateSearch('')}
          variant="secondary"
        >
          <FaXmark />
        </Button>
      )}
    </Form.Group>
  );
}
